// extracted by mini-css-extract-plugin
export default {"replaceInput":"Custom_replaceInput__yqZwj","inputField":"Custom_inputField__+Zzxw","input":"Custom_input__1DW7u"};